import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '../../../shared/services/toast.service';
import { FormSetupComponent } from "../../../shared/component/form-setup/form-setup.component";
import { HttpClient } from '@angular/common/http';
import { ApiCallsService } from '../../../shared/services/api-calls.service';
import { addSiteJson } from '../../../shared/services/formJson';
import { Country } from 'country-state-city';

@Component({
  selector: 'app-add-sites',
  imports: [CommonModule, FormSetupComponent],
  templateUrl: './add-sites.component.html',
  styleUrl: './add-sites.component.scss'
})
export class AddSitesComponent implements OnInit,OnDestroy {
  countries: any[] = [];
  states: any[] = [];
  cities: any[] = [];
  selectedCountry: any;
  selectedState: any;

  ngOnInit(): void {
  this.ApiService.populateApiOptions(this.formConfig).subscribe(() => {
    // console.log('API options populated ✅');
  });
    this.injectCountriesIfNeeded(); 
  }
  
  injectCountriesIfNeeded(): void {
  if (!this.formConfig) {
    console.log('noform');
    return;
  }

    const hasCountry = this.formConfig.some((item: any) => item.id === 'country');
    if (hasCountry) {
      const countries = Country.getAllCountries().map(c => ({
        id: c.isoCode,
        name: c.name
      }));
      console.log(
        countries
      );
      

      this.formConfig = this.formConfig.map((item: any) =>
        item.id === 'country'
          ? { ...item, options: { list: countries } }
          : item
      );
      this.cdr.markForCheck();
    }
  }

  callForForm:boolean = false

  constructor(private toast : ToastService,private http: HttpClient,private ApiService:ApiCallsService,private cdr : ChangeDetectorRef){
    
  }
  ngOnDestroy(): void {
    this.formConfig = []
  }
  triggerSubmit() {
    this.callForForm = true;
    setTimeout(() => this.callForForm = false, 0); // reset after change detection        
  }

formResponses: { [id: string]: any } = {};

formSubmit(payload: boolean){
    if (payload) {
    console.log();
      this.formResponses['addsites'] = {
        ...this.formResponses['addsites'], // keep existing keys
        recharge_mode: 'DIRECT'            // ✅ your hardcoded value
      };
      this.ApiService.addSites(this.formResponses['addsites']).subscribe(res=>{
        console.log(res);
        this.toast.showToast('Form is Submitted', 'colored', 6000, 'success');
      })
    }
    else{
      this.toast.showToast('All Required Fields are Not filled', 'colored', 6000, 'danger');
    }
}

submitform(payload: { id: string; value: any }) {
  console.log("📥 Received payload:", payload);
  // If this id already exists, merge the values
  if (this.formResponses[payload.id]) {
    this.formResponses[payload.id] = {
      ...this.formResponses[payload.id],
      ...payload.value
    };
  } else {
    this.formResponses[payload.id] = payload.value;
  }
  console.log("📦 Combined responses:", this.formResponses);

}

formConfig:any = addSiteJson

}